export default __webpack_public_path__ + "static/media/Pipe Welding.8172b8da.jpg";